import { number } from "prop-types";

import useIsMobile from "Utilities/Hooks/useIsMobile";
import useOpenHouseholdProfile from "Utilities/Hooks/useOpenHouseholdProfile";
import useUrlParams from "Utilities/Hooks/useUrlParams";

import SidebarLinkButton from "../GoToGivingTab/SidebarLinkButton";
import { useProfileSidebarContext } from "../ProfileSidebar/ProfileSidebar";

import { useShouldShowFamilyInfoInSidebar } from "./useShouldShowFamilyInfoInSidebar";

const GoToProfile = ({ userID, householdID, ...rest }) => {
  const { profileTab } = useUrlParams();
  const isViewingHouseholdInfo = Boolean(householdID) && !profileTab; // undefined profileTab means householdInfo is the tab
  const openHouseholdProfile = useOpenHouseholdProfile({ householdID });
  const { setShowHousehold } = useProfileSidebarContext();
  const isMobile = useIsMobile(680);

  const onClick = () => {
    openHouseholdProfile();
    if (isMobile) setShowHousehold(false);
  };

  const shouldShow = useShouldShowFamilyInfoInSidebar();

  if (!shouldShow) return null;

  return (
    <SidebarLinkButton
      onClick={onClick}
      isActive={isViewingHouseholdInfo}
      icon={`info-circle ${isViewingHouseholdInfo ? "fas" : "far"}`}
      text="Family Info"
      {...rest}
    />
  );
};

GoToProfile.propTypes = {
  userID: number,
  householdID: number,
};

export default GoToProfile;
